import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Goal_list() {
    const [listGoals, setListGoals] = useState([]);
    const [removeGoalId, setRemoveGoalId] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];

        const isSuperAdmin = storedPermissions.includes("goals.view_all");

        const trgval = isSuperAdmin
            ? localStorage.getItem('mem_company_id')
            : localStorage.getItem('member_id');

        const adminmember = isSuperAdmin ? "Super Admin" : "Member";

        var obj = {
            trgid: trgval,
            usertype: adminmember
        }
        console.log(obj);
        $.ajax({
            type: 'POST',
            url: 'getAllgoals.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListGoals(parsedResult);
                    } else {
                        showAlert('No goal created by you.');
                        setListGoals([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load goals data.');
                    setListGoals([]); // fallback to prevent map crash
                }
            },
        });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function goToGoalDetails(id) {
        localStorage.setItem('goal_id', id);
        navigate('/goal_details');
    }
    function deleteGoalInfo(id) {
        setRemoveGoalId(id)
        $('#goalRemove').css('display', 'block')
    }
    function clsoeMemGoalremove() {
        setRemoveGoalId('');
        $('#goalRemove').css('display', 'none')
    }

    function removeGoal() {
        var obj = {
            primary_key: removeGoalId
        }
        $.ajax({
            type: 'POST',
            url: 'removeGoal.php',
            data: obj,
            cache: false,
            success: function (result) {
                if (result != 'fail') {
                    showAlert('Removed successfully');
                    setTimeout(resetGoals, 1500)
                } else {
                    showAlert('Cannot remove project.');
                }
            },
        });
    }
    function resetGoals() {
        navigate('/re_goallist');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Goals</h2>
                    <Link className='pull_right add_new_pro' to="/create_goal">Create Goal</Link>
                </div>
                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full'>
                                {listGoals.length > 0 && (
                                    <>
                                        {listGoals.map((listGoal, index) => (
                                            <div className='resource_card_one_third' key={index}>
                                                <div className='resource_inner'>
                                                    <div className='fullwidth pull_left pt-21'>
                                                        <h3>{listGoal.title}</h3>
                                                        <div className='fullwidth pull_left pb-10'>
                                                            <span>Status: {listGoal.status}</span>
                                                        </div>
                                                    </div>
                                                    <div className='divider'>&nbsp;</div>
                                                    <div className='vl_dsh_one_half'>
                                                        <p>Start: {listGoal.start_date}</p>
                                                    </div>
                                                    <div className='vl_dsh_one_half'>
                                                        <p>End: {listGoal.end_date}</p>
                                                    </div>
                                                    <div className='vl_dsh_one_half'>
                                                        <p>Category: {listGoal.category}</p>
                                                    </div>
                                                    <div className='vl_dsh_one_half'>
                                                        <p>Create: {listGoal.created_at}</p>
                                                    </div>

                                                    <div className='list_buttonholder'>

                                                        <span className='catbtn viewbtn'><button onClick={() => { goToGoalDetails(listGoal.id) }}><i className='ri-eye-line'></i> View</button></span>

                                                        <span className='catbtn delbtn'><button onClick={() => { deleteGoalInfo(listGoal.id) }}><i className='ri-delete-bin-3-line'></i> Delete</button></span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}


                                        {/* 📄 PDF Button 
                                        <button className='downlaodBTN'
                                            style={{ marginTop: '15px' }}
                                            onClick={downloadPDF}                                        >
                                            Download PDF <i className='ri-download-2-fill'></i>
                                        </button>*/}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div >


            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            <div className='vl_dsh_popup' id="goalRemove">
                <div className='memlistareashort'>

                    <div className='memlistcontainer'>
                        <p>Are you sure you want to remove this goal?</p>
                        <div className='vl_dsh_buttonholder'>
                            <button onClick={removeGoal}>Yes</button>
                            <button className='closebtn' onClick={clsoeMemGoalremove}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
